<template>
  <div class="question-container">
    <div class="question-title-container">
      <!-- <el-tag v-show="isRequired" class="title-tag" color="#F56C6C">{{ $t(`${i18nPrefix}.label.required`) }}</el-tag>
      <el-tag class="title-tag" :color="QUESTION_TYPE_COLOR[type]" :style="{ borderColor: QUESTION_TYPE_COLOR[type] }">{{ $t(`${i18nPrefix}.questionType.${type}`) }}</el-tag> -->
      <span v-show="!isHrSurvey" class="question-title">{{ $t(`${i18nPrefix}.label.question`) }}</span>
      <a v-if="type === QUESTION_TYPE.POLICY" class="question-title link" target="_blank" :href="policyLink" v-html="title"></a>
      <span v-else class="question-title" v-html="title"></span>
    </div>
    <div v-show="errorMessage" class="error-message">{{ errorMessage }}</div>
    <div class="question-answer-wrapper">
      <el-select v-if="type === QUESTION_TYPE.SELECT" filterable clearable v-model="answerValue" class="question-answer">
        <el-option v-for="(option, index) in optionList" :key="index" :value="option.value" :label="option.label"></el-option>
      </el-select>
      <el-select v-else-if="type === QUESTION_TYPE.MULTIPLE" filterable multiple clearable v-model="answerValue" class="question-answer">
        <el-option v-for="(option, index) in optionList" :key="index" :value="option.value" :label="option.label"></el-option>
      </el-select>
      <el-radio-group v-else-if="type === QUESTION_TYPE.RADIO" v-model="answerValue" class="question-answer">
        <el-radio v-for="(option, index) in optionList" class="question-option" :key="index" :label="option.value">{{ option.label }}</el-radio>
      </el-radio-group>
      <el-checkbox-group v-else-if="type === QUESTION_TYPE.CHECKBOX" v-model="answerValue" class="question-answer">
        <el-checkbox v-for="(option, index) in optionList" class="question-option" :key="index" :label="option.value">{{ option.label }}</el-checkbox>
      </el-checkbox-group>
      <el-date-picker v-else-if="type === QUESTION_TYPE.DATE" v-model="answerValue" class="question-answer" type="date"></el-date-picker>
      <el-checkbox v-else-if="type === QUESTION_TYPE.POLICY" v-model="answerValue" class="question-answer">{{ $t(`${i18nPrefix}.label.agree`) }}</el-checkbox>
      <el-input v-else-if="type === QUESTION_TYPE.TEXTAREA" v-model="answerValue" class="question-answer" type="textarea" :autosize="this.autosize || { minRows: 4 }"></el-input>
      <div v-else-if="[QUESTION_TYPE.ATTACHMENT, QUESTION_TYPE.VIDEO].includes(type)" class="question-answer file-uploader">
        <input v-show="false" ref="fileInput" type="file" :accept="uploadFileAcceptType" @change="handleFileChange"/>
        <div class="file-status">
          <i class="status-icon" :class="fileStatusIconClass"></i>
          <span class="status">{{ fileStatusLabel }}</span>
        </div>
        <el-button class="upload-btn" :disabled="isUploading" @click="handleUploadBtnClick">{{ $t(`${i18nPrefix}.btn.upload.${hasUploaded ? 'selectAnotherFile' : 'selectFile'}`) }}</el-button>
        <div class="upload-tip">
          <div v-for="(item, index) in uploaderTipList" class="tip-message" :key="index">{{ item }}</div>
        </div>
        <div v-if="uploaderNeedFileDescription" class="file-description">
          <el-input v-model="fileDescription" :placeholder="$t(`${i18nPrefix}.placeholder.uploadFileDescription`)"></el-input>
        </div>
      </div>
      <el-input v-else v-model="answerValue" class="question-answer"></el-input>
    </div>
  </div>
</template>

<script>

export const QUESTION_TYPE = {
  TEXT: 'TEXT',
  TEXTAREA: 'TEXTAREA',
  SELECT: 'SELECT',
  RADIO: 'RADIO',
  CHECKBOX: 'CHECKBOX',
  DATE: 'DATE',
  VIDEO: 'VIDEO',
  ATTACHMENT: 'ATTACHMENT',
  POLICY: 'POLICY',
  MULTIPLE: 'MULTIPLE'
}

const QUESTION_TYPE_COLOR = {
  [QUESTION_TYPE.TEXT]: '#67C23A',
  [QUESTION_TYPE.TEXTAREA]: '#67C23A',
  [QUESTION_TYPE.SELECT]: '#E6A23C',
  [QUESTION_TYPE.RADIO]: '#E6A23C',
  [QUESTION_TYPE.CHECKBOX]: '#E6A23C',
  [QUESTION_TYPE.DATE]: '#909399',
  [QUESTION_TYPE.VIDEO]: '#409EFF',
  [QUESTION_TYPE.ATTACHMENT]: '#409EFF',
  [QUESTION_TYPE.POLICY]: '#409EFF'
}

export default {
  model: {
    prop: 'answer',
    event: 'change'
  },
  props: {
    isRequired: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: null
    },
    type: {
      type: String,
      required: true
    },
    surveyType: {
      type: String,
      default: 'standard'
    },
    answer: {
      default: null
    },
    optionList: {
      type: Array,
      default: null
    },
    uploaderTipList: {
      type: Array,
      default: null
    },
    uploaderFileSize: {
      type: Number,
      default: null
    },
    uploaderFileTypeList: {
      type: Array,
      default: null
    },
    uploaderNeedFileDescription: {
      type: Boolean,
      default: false
    },
    uploaderFileDescription: {
      type: String,
      default: null
    },
    policyLink: {
      type: String,
      default: null
    },
    errorMessage: {
      type: String,
      default: null
    },
    autosize: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      QUESTION_TYPE,
      QUESTION_TYPE_COLOR,
      i18nPrefix: 'admin.application.candidate',
      isUploading: false
    }
  },
  computed: {
    fileStatusLabel () {
      let i18nKey = null
      if (this.isUploading) {
        i18nKey = 'uploading'
      } else if (this.hasUploaded) {
        i18nKey = 'uploaded'
      } else {
        i18nKey = 'empty'
      }
      return this.$t(`${this.i18nPrefix}.fileUpload.${i18nKey}`)
    },
    fileStatusIconClass () {
      let className = null
      if (this.isUploading) {
        className = 'el-icon-loading uploading'
      } else if (this.hasUploaded) {
        className = 'el-icon-circle-check uploaded'
      } else {
        className = 'el-icon-warning-outline empty'
      }
      return className
    },
    hasUploaded () {
      return !this.isUploading && this.answerValue
    },
    uploadFileAcceptType () {
      if (this.uploaderFileTypeList) {
        return this.uploaderFileTypeList.join(',')
      }
      return null
    },
    answerValue: {
      get () {
        return this.answer
      },
      set (val) {
        this.$emit('change', val)
      }
    },
    fileDescription: {
      get () {
        return this.uploaderFileDescription
      },
      set (val) {
        this.$emit('update:uploaderFileDescription', val)
      }
    },
    isHrSurvey () {
      if (this.surveyType === 'hr') {
        return true
      }
      return false
    }
  },
  created () {

  },
  methods: {
    handleUploadBtnClick () {
      this.$refs.fileInput.click()
    },
    handleFileChange () {
      const fileInput = this.$refs.fileInput
      const selectedFile = fileInput.files[0]
      if (!selectedFile) {
        return
      }
      this.isUploading = true
      this.$emit('file-upload', selectedFile, this.handleFileUploaded)
    },
    handleFileUploaded () {
      this.isUploading = false
      this.$refs.fileInput.value = null
    }
  }
}
</script>

<style lang="scss" scoped>
.question-container {
  margin-bottom: 25px;

  .question-title-container {
    .title-tag {
      height: initial;
      margin-right: 5px;
      padding: 2px 8px;
      border-radius: 6px;
      border-width: 0;
      line-height: initial;
      color: #ffffff;
      vertical-align: middle;
    }

    .question-title {
      height: 32px;
      line-height: 32px;
      font-size: 18px;
      vertical-align: middle;
      white-space: break-spaces;
      word-break: break-word;
    }
  }

  .error-message {
    color: #F56C6C;
    font-size: 14px;
  }

  .question-answer-wrapper {
    margin-top: 5px;

    .question-answer {
      width: 100%;

      .question-option {
        display: inline-block;
        width: 100%;
        margin-right: 0;

        + .question-option {
          margin-top: 10px;
        }
      }

      &.file-uploader {
        .file-status {
          .status-icon {
            position: relative;
            top: 2px;
            font-size: 18px;

            &.empty {
              color: #E6A23C;
            }

            &.uploaded {
              color: #67C23A;
            }
          }

          .status {
            margin-left: 5px;
            font-size: 14px;
          }
        }

        .upload-btn {
          margin-top: 10px;
          padding: 10px 15px;
          border: 0;
          background-color: #409EFF;
          color: #ffffff;
        }

        .upload-tip {
          margin-top: 5px;
          font-size: 12px;
        }

        .file-description {
          margin-top: 10px;
        }
      }
    }

    ::v-deep {
      .el-select {
        width: 100%;

        .el-input {
          .el-input__icon {
            line-height: inherit;
          }

          &.is-focus {
            .el-input__inner {
              border-color: #409EFF;
            }
          }
        }

        .el-select__input {
          margin-left: 5px;
        }
      }

      .el-input {
        .el-input__inner {
          height: 32px;
          line-height: 32px;
          padding: 0 5px;
          border-radius: 0;
          color: #232323;

          &:focus {
            border-color: #b2b2b2;
          }

          &:hover {
            border-color: #C0C4CC;
          }
        }

        &.el-input--prefix {
          .el-input__inner {
            padding-left: 30px;
          }

          .el-input__prefix {
            .el-input__icon {
              line-height: inherit;
            }
          }
        }

        &.el-input--suffix {
          .el-input__suffix {
            .el-input__icon {
              line-height: inherit;
            }
          }
        }

        &.password-input {
          .el-input__inner {
            padding-right: 50px;
          }

          .el-input__suffix {
            right: 20px;
          }
        }

        &.is-disabled  {
          .el-input__inner {
            background-color: #F5F7FA;
            border-color: #E4E7ED;
            color: #C0C4CC;
            cursor: not-allowed;
          }
        }
      }

      .el-textarea {
        .el-textarea__inner {
          padding: 5px 10px;
          border-radius: 0;
        }
      }

      .el-date-editor {
        width: 100%;

        .el-input__icon {
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }
}
</style>
